// Notes internes d'un dossier : fond distinct et mention « Interne, invisible par l'usager »,
// ajout réservé au droit de modifier. Jamais mêlées à la conversation usager.
import type { NoteInterne } from '@cc/contrats/ui-metier';
import { Bandeau, Bouton, Panneau, Squelette, ZoneTexte } from '@cc/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { requete } from '../../../api/client';
import { AffichageErreur } from '../../../commun/EtatRequete';
import { dateHeure } from '../../../commun/format';
import { useAction } from '../../../commun/useAction';
import commun from '../../../commun/commun.module.css';
import styles from '../metier.module.css';

export function NotesInternes({ dossierId, peutAjouter }: { dossierId: string; peutAjouter: boolean }) {
  const [texte, setTexte] = useState('');
  const notes = useQuery({
    queryKey: ['dossiers', 'notes', dossierId],
    queryFn: ({ signal }) => requete<{ elements: NoteInterne[] }>(`/dossiers/${dossierId}/notes`, { signal }).then((r) => r.elements),
    retry: false,
  });
  const ajout = useAction({
    executer: () => requete(`/dossiers/${dossierId}/notes`, { methode: 'POST', corps: { contenu: texte } }),
    succes: 'Note interne enregistrée.',
    invalider: [['dossiers', 'notes', dossierId]],
    apres: () => setTexte(''),
  });
  return (
    <Panneau titre="Notes internes" interne>
      {notes.isPending ? (
        <Squelette lignes={2} />
      ) : notes.error ? (
        <AffichageErreur erreur={notes.error} lot="L0-C" fonction="Les notes internes" />
      ) : notes.data.length === 0 ? (
        <p>Aucune note interne.</p>
      ) : (
        <ul className={styles.listePieces}>
          {notes.data.map((n) => (
            <li key={n.id}>
              <span>{n.contenu}</span>
              <span className={commun.na}>
                {n.auteur.nom ?? 'agent'}, {dateHeure(n.cree_le)}
              </span>
            </li>
          ))}
        </ul>
      )}
      {!notes.error && peutAjouter ? (
        <form
          className={styles.pile}
          onSubmit={(e) => {
            e.preventDefault();
            if (texte.trim()) ajout.lancer(undefined);
          }}
        >
          <ZoneTexte libelle="Nouvelle note interne" value={texte} onChange={(e) => setTexte(e.target.value)} aide="Jamais visible par l'usager, ni dans le portail ni dans les documents" />
          {ajout.messageErreur ? <Bandeau type="erreur">{ajout.messageErreur}</Bandeau> : null}
          <div>
            <Bouton type="submit" variante="secondaire" chargement={ajout.enCours} disabled={!texte.trim()}>
              Ajouter la note
            </Bouton>
          </div>
        </form>
      ) : null}
    </Panneau>
  );
}
